import { combineReducers } from 'redux';
import { submitClaimReducer } from 'apps/member-experience/pages/claims/submit-claim/state/submit-claim.reducer';

export const uiReducer = combineReducers({
  submitClaim: submitClaimReducer,
});
